export const CREATE_PROCESS_TYPE_REQUESTED = 'CREATE_PROCESS_TYPE_REQUESTED';
export const CREATE_PROCESS_TYPE_SUCCEEDED = 'CREATE_PROCESS_TYPE_SUCCEEDED';
